import { render, staticRenderFns } from "./IpMultiplierButton.vue?vue&type=template&id=79ab45ba&scoped=true"
import script from "./IpMultiplierButton.vue?vue&type=script&lang=js"
export * from "./IpMultiplierButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ab45ba",
  null
  
)

export default component.exports